import type { AuditEvent } from '../../api/types';
import { Badge } from '../../ui/Badge';
import { Timestamp } from '../../ui/Timestamp';

const SOURCE: Record<string, string> = { ui: 'UI', mcp: 'MCP', system: 'System' };

/** Audit rows: actor, source, human authority, reason and server time (AUD-01). */
export function EventTable({
  events,
  showIds,
}: {
  events: AuditEvent[];
  projectKey?: string;
  showIds?: boolean;
}) {
  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            <th style={{ width: 170 }}>Server time</th>
            <th>Actor</th>
            <th>Source</th>
            <th>Event</th>
            <th>Authority / reason</th>
            {showIds && <th>Correlation</th>}
          </tr>
        </thead>
        <tbody>
          {events.map((e) => (
            <tr key={e.id}>
              <td className="small">
                <Timestamp value={e.occurredAt} />
              </td>
              <td>
                {e.actor.name}
                {e.actor.kind === 'ai_service' && <span className="muted small"> (AI)</span>}
              </td>
              <td>
                <Badge dot={false}>{SOURCE[e.source] ?? e.source}</Badge>
                {e.requestOrigin && e.requestOrigin !== e.source && (
                  <span className="small muted"> · requested via {SOURCE[e.requestOrigin]}</span>
                )}
              </td>
              <td>
                <div className="ink">{e.summary}</div>
                <div className="mono small muted">{e.type}</div>
              </td>
              <td className="small">
                {e.approvingUserId && <div>Human authority recorded{e.approvalId ? ' (approval)' : ''}</div>}
                {e.reason && <div className="muted">“{e.reason}”</div>}
                {!e.approvingUserId && !e.reason && <span className="muted">—</span>}
              </td>
              {showIds && <td className="mono small muted">{e.correlationId.slice(0, 12)}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
